import AnswerButtonGroup from '@/components/train/AnswerButtonGroup.vue';
import OpticalPathBoard from './OpticalPathBoard.vue';
export default {
  name: 'OpticalPathInferenceRender',
  components: {
    AnswerButtonGroup,
    OpticalPathBoard
  },
  props: {
    data: {
      type: Object,
      default: null
    },
    review: {
      type: Object,
      default: null
    },
    reviewMode: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    hasStructuredConfig() {
      return Boolean(this.data?.opticalConfig?.cases?.length && this.data?.opticalConfig?.target && this.data?.opticalConfig?.options?.length === 4);
    },
    hasSeparateOptionImages() {
      return this.data?.optionImages?.length === (this.data?.options?.length || 4);
    }
  },
  methods: {
    onChoose(value) {
      this.$emit('answer', value?.length ? value[0] : null);
    }
  }
};